import { render, staticRenderFns } from "./SendTemplatesTable.vue?vue&type=template&id=ed184e88&scoped=true&"
import script from "./SendTemplatesTable.vue?vue&type=script&lang=js&"
export * from "./SendTemplatesTable.vue?vue&type=script&lang=js&"
import style0 from "./SendTemplatesTable.vue?vue&type=style&index=0&id=ed184e88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed184e88",
  null
  
)

export default component.exports